/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $LogEntry = {
    properties: {
        id: {
            type: 'string',
            isRequired: true,
        },
        userId: {
            type: 'any-of',
            contains: [{
                type: 'number',
            }, {
                type: 'null',
            }],
            isRequired: true,
        },
        action: {
            type: 'string',
            isRequired: true,
        },
        timestamp: {
            type: 'string',
            isRequired: true,
            format: 'date-time',
        },
        entity_type: {
            type: 'string',
            isRequired: true,
        },
        entity_id: {
            type: 'string',
            isRequired: true,
        },
        details: {
            type: 'LogDetails',
            isRequired: true,
        },
        status_code: {
            type: 'number',
            isRequired: true,
        },
        duration: {
            type: 'number',
            isRequired: true,
        },
    },
} as const;
